module.exports = __webpack_public_path__ + "static/media/wrecker_white.edd7179b.svg";